export enum PathParam {
  SaleId = 'saleId',
  RaffleURI = 'raffleURI',
  StoryName = 'storyName',
}
